import i18next from "../../../i18n";

i18next.addResourceBundle("en", "UpdateDocuments", {
    success_message: "Documents updated successfully",
});

i18next.addResourceBundle("fr", "UpdateDocuments", {
    success_message: "Documents mis à jour avec succès",
});
